import React from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import FormikField from '@sls-react/components/Form/FormikField';
import { Button } from '@sls-react/components/Form/Button';
import { useRouter } from '@sls-react/routing';
import { Label } from '@sls-react/design-system';
import FormikInput from '@sls-react/components/Form/FormikInput';
import FormikFieldError from '@sls-react/components/Form/FormikFieldError';
import Cookies from 'js-cookie';
import { KnownCookie } from '@sls-react/typings/cookies';
import { fireEmailCaptured } from '@sls-react/services/analytics/events/item';
import { AnalyticsSource } from '@sls-react/services/analytics/AnalyticsInterfaces';

interface EmailCaptureFormValues {
  email: string;
}

const schema: yup.SchemaOf<EmailCaptureFormValues> = yup.object({
  email: yup.string().required('Required').email('Enter a valid email'),
});

interface Props {
  onSuccessfulSubmit: () => void;
  src?: AnalyticsSource;
}

const EmailCaptureForm: React.FC<Props> = ({ onSuccessfulSubmit, src }) => {
  const router = useRouter();
  return (
    <Formik
      initialValues={{ email: '' }}
      validationSchema={schema}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={async (values, formikHelpers) => {
        fireEmailCaptured({
          email: values.email,
          pageName: router.asPath,
          src,
        });
        onSuccessfulSubmit();
        Cookies.set('email_captured' as KnownCookie, '1', {
          expires: 700,
        });
      }}
    >
      {props => (
        <Form>
          <div className="flex items-end space-x-4">
            <FormikInput
              name="email"
              type="email"
              className="flex-1"
              placeholder="Enter your email"
            />
            <Button className="h-10" type="submit">
              Subscribe
            </Button>
          </div>
          <FormikFieldError name="email" />
        </Form>
      )}
    </Formik>
  );
};

export default EmailCaptureForm;
